class NavigationMenu extends HTMLElement {
  connectedCallback() {
    // Seed a skeleton placeholder shown until the menu data is fetched
    // and render() replaces this innerHTML with the real menu.
    this.innerHTML = `
            <div class="main-menu-skel" aria-hidden="true">
                <span class="header-skel-item header-skel-item--menu" style="width:80px"></span>
                <span class="header-skel-item header-skel-item--menu" style="width:60px"></span>
                <span class="header-skel-item header-skel-item--menu" style="width:90px"></span>
                <span class="header-skel-item header-skel-item--menu" style="width:70px"></span>
                <span class="header-skel-item header-skel-item--menu" style="width:80px"></span>
            </div>`;
    salla
      .onReady()
      .then(() => salla.lang.onLoaded())
      .then(() => {
        this.menus = [];
        this.displayAllText = salla.lang.get("blocks.home.display_all");

        return salla.api.component
          .getMenus()
          .then(({ data }) => {
            this.menus = data;
            return this.render();
          })
          .catch((error) =>
            salla.logger.error("salla-menu::Error fetching menus", error),
          );
      });
  }

  hasChildren(menu) {
    return menu?.children?.length > 0;
  }

  hasProducts(menu) {
    return menu?.products?.length > 0;
  }

  getDesktopClasses(menu, isRootMenu) {
    return `!hidden lg:!block ${isRootMenu ? "root-level lg:!inline-block" : "relative"} ${menu.products ? " mega-menu" : ""}
        ${this.hasChildren(menu) ? " has-children" : ""}`;
  }

  getMobileMenu(menu, displayAllText) {
    const menuImage = menu.image
      ? `<img src="${menu.image}" class="w-12 rounded-full object-cover aspect-square" width="100" height="100" alt="" />`
      : "";
    return `
        <li class="lg:hidden text-sm font-bold" ${menu.attrs}>
            ${
              !this.hasChildren(menu)
                ? `
                <a href="${menu.url}" aria-label="${menu.title || "category"}" class="text-gray-500 ${menu.image ? "!py-3" : ""}" ${menu.link_attrs}>
                    ${menuImage}
                    <span>${menu.title || ""}</span>
                </a>`
                : `
                <span class="${menu.image ? "!py-3" : ""}">
                    ${menuImage}
                    ${menu.title}
                </span>
                <ul>
                    <li class="text-sm font-bold">
                        <a href="${menu.url}" class="text-gray-500">${displayAllText}</a>
                    </li>
                    ${menu.children.map((subMenu) => this.getMobileMenu(subMenu, displayAllText)).join("")}
                </ul>
            `
            }
        </li>`;
  }

  getDesktopMenu(menu, isRootMenu) {
    return `
            <li class="${this.getDesktopClasses(menu, isRootMenu)}" ${menu.attrs || ""}>
                <a href="${menu.url}" aria-label="${menu.title || "category"}" ${menu.link_attrs || ""}>
                    <span>${menu.title || ""}</span>
                </a>
                ${
                  this.hasChildren(menu)
                    ? `
                    <div class="sub-menu ${this.hasProducts(menu) ? "w-full left-0 flex" : "w-56"}">
                        <ul class="${this.hasProducts(menu) ? "w-56 shrink-0 m-8 rtl:ml-0 ltr:mr-0" : ""}">
                            ${menu.children.map((subMenu) => this.getDesktopMenu(subMenu, false)).join("\n")}
                        </ul>
                        ${
                          this.hasProducts(menu)
                            ? `
                            <salla-products-list
                                source="selected"
                                shadow-on-hover
                                source-value="[${menu.products}]"></salla-products-list>`
                            : ""
                        }
                    </div>`
                    : ""
                }
            </li>
        `;
  }

  getMenus() {
    return this.menus
      .map(
        (menu) => `
        ${this.getMobileMenu(menu, this.displayAllText)}
    `,
      )
      .join("\n");
  }

  renderDesk() {
    return this.menus
      .map(
        (menu) => `
        ${this.getDesktopMenu(menu, true)}
    `,
      )
      .join("\n");
  }
  render() {
    const centered_logo =
      typeof window.centered_logo !== "undefined"
        ? window.centered_logo
        : false;
    const div = document.querySelector(".getDeskMenue");

    this.innerHTML = `
        <nav id="mobile-menu" class="mobile-menu">
            <ul class="main-menu ">
                ${this.getMenus()}
            </ul>
            <button class="btn--close close-mobile-menu sicon-cancel  ${centered_logo ? "" : "lg:hidden"}"></button>
        </nav>
    `;

    if (div) {
      div.innerHTML = `
            <nav id="menu" class="menu">
                <ul class="main-menu desk">
                    ${this.renderDesk()}
                </ul>
            </nav>
        `;
    } else {
      salla.logger.warn(
        "getDeskMenue element not found, skipping desktop menu rendering.",
      );
    }
  }
}

if (!customElements.get("custom-main-menu")) {
  customElements.define("custom-main-menu", NavigationMenu);
}
